/*
  Whino · La foto grande de la ficha cambia al PASAR EL CURSOR por una
  miniatura, sin necesidad de pinchar (como en OK Perfumes).

  Decisiones y porques, para que se entienda dentro de seis meses:

  - Solo con raton de verdad: se filtra por pointerType === 'mouse' y por la
    media query (hover:hover) and (pointer:fine). En movil y en tablet no se
    activa nada, alli manda el toque de siempre.
  - No se toca assets/media-gallery.js (fichero de Dawn) para que una
    actualizacion del tema no se lleve esto por delante. El clic sigue
    funcionando exactamente igual que antes.
  - No se llama a setActiveMedia de Dawn a proposito: esa funcion hace
    scroll de la pagina, avisa al lector de pantalla y reinicia el src de la
    imagen. Todo eso esta bien para un clic deliberado, pero pasando el raton
    daria saltos y ruido. Aqui solo se intercambia la clase is-active.
  - Retardo de 60 ms: evita el parpadeo cuando el cursor solo cruza por encima
    de las miniaturas de camino a otro sitio.
  - La foto se queda en la ultima que has mirado (no vuelve sola a la
    principal): volver produce un parpadeo constante al mover el raton.
  - Los videos y los modelos 3D quedan fuera: no queremos que empiece a sonar
    un video solo por pasar por encima.
*/
(function () {
  'use strict';

  var RETARDO = 60;
  var raton = window.matchMedia('(hover: hover) and (pointer: fine)');
  var timer = null;

  function esImagen(slide) {
    // los medios que no son imagen traen .deferred-media (video, modelo 3D)
    return slide && !slide.querySelector('.deferred-media');
  }

  function activar(galeria, mediaId) {
    var visor = galeria.querySelector('[id^="GalleryViewer"]');
    var miniaturas = galeria.querySelector('[id^="GalleryThumbnails"]');
    if (!visor || !miniaturas) return;

    var destino = visor.querySelector('[data-media-id="' + mediaId + '"]');
    if (!destino || destino.classList.contains('is-active')) return;
    if (!esImagen(destino)) return;

    visor.querySelectorAll('[data-media-id]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    destino.classList.add('is-active');

    miniaturas.querySelectorAll('button').forEach(function (b) {
      b.removeAttribute('aria-current');
    });
    var li = miniaturas.querySelector('[data-target="' + mediaId + '"]');
    if (li && li.querySelector('button')) li.querySelector('button').setAttribute('aria-current', 'true');

    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
  }

  // Delegado en document: asi sigue funcionando aunque Shopify vuelva a
  // pintar la seccion al cambiar de variante o al abrir un quick-add.
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !raton.matches) return;
    if (!e.target || !e.target.closest) return;

    var li = e.target.closest('.thumbnail-list__item[data-target]');
    if (!li) return;

    var galeria = li.closest('media-gallery');
    if (!galeria) return;

    // en el quick-add / la ventana emergente no interesa
    if (galeria.closest('.quick-add-modal')) return;

    clearTimeout(timer);
    var destino = li.dataset.target;
    timer = setTimeout(function () {
      activar(galeria, destino);
    }, RETARDO);
  }, { passive: true });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    if (e.target && e.target.closest && e.target.closest('.thumbnail-list__item')) clearTimeout(timer);
  }, { passive: true });
})();
